import * as React from 'react'

import LoadingCover from '../../components/loadingCover'

interface IProps {
  url: string
}

const Redirect = ({ url }: IProps) => {
  if (typeof window !== 'undefined') {
    window.location.href = url
  }
  return <LoadingCover />
}

export default Redirect
